// import libraries
import { useRef, useState, useCallback, useMemo } from 'react';
// import hooks
import { useLandingPage } from './useLandingPage';

/**
 * Custom hook to encapsulate all logic/state for LandingPage.
 * Follows the architecture guide: useRef for mutable, useState for processed, useCallback/useMemo for memoization.
 */
export function useLandingLogic() {
  // Use the original landing page logic
  const {
    isMobile,
    isLoading,
    accessError,
    toast,
    demoChatUrl,
    handleGoogleSignIn,
    handleTryDemo
  } = useLandingPage();

  // Mutable ref for bionicEnabled toggle (doesn't trigger rerender)
  const bionicEnabledRef = useRef(false);
  // State for bionicEnabled (triggers rerender only after toggle)
  const [bionicEnabled, setBionicEnabled] = useState(false);

  // Handler to toggle bionic reading
  const toggleBionic = useCallback((value) => {
    bionicEnabledRef.current = value;
    setBionicEnabled(value);
  }, []);

  // Memoize values that are passed as props
  const logic = useMemo(() => ({
    isMobile,
    isLoading,
    accessError,
    toast,
    demoChatUrl,
    handleGoogleSignIn,
    handleTryDemo,
    bionicEnabled,
    toggleBionic
  }), [isMobile, isLoading, accessError, toast, demoChatUrl, handleGoogleSignIn, handleTryDemo, bionicEnabled, toggleBionic]);

  return logic;
}
